const ignoreChars = new Set(['µ']);

export default function uppercaseProductValue(value: string | null | undefined): string | null {
	if (value === null || value === undefined) {
		return value ?? null;
	}
	return Array.from(value)
		.map((char) => (ignoreChars.has(char) ? char : char.toUpperCase()))
		.join('');
}
